import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { UserPermission } from '../models/permissions';
import { CognitoAuthService } from '../services/cognito-auth.service';

@Injectable({
  providedIn: 'root',
})
export class ReportsGuard {
  constructor(
    private cognitoAuthService: CognitoAuthService,
    private router: Router
  ) {}

  canActivate() {
    return this.cognitoAuthService.loggedInConnect$.pipe(
      map((user) => {
        if (!user) {
          this.router.navigate(['secure']);
          return false;
        }

        const isAuthorised = user.permissions.has(
          UserPermission.ClientReportsRead
        );

        if (!isAuthorised) {
          this.router.navigate(['/not-found']);
          return false;
        }

        return isAuthorised;
      })
    );
  }
}
